import {
  Component,
  OnInit,
  Input,
  ChangeDetectionStrategy,
} from '@angular/core';

@Component({
  selector: 'app-total-stat',
  templateUrl: './total-stat.component.html',
  styleUrls: ['./total-stat.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TotalStatComponent implements OnInit {
  @Input() data: any[];
  @Input() locale: string;
  @Input() title: string;
  @Input() tooltipText: string;
  @Input() defaultCurrency: string;

  constructor() {}

  ngOnInit() {}
}
